module.exports = __webpack_public_path__ + "img/Man.03325c70.svg";